import { Stack } from "@mantine/core";
import { useSystemEmailCatalogue } from "../../../hooks/admin/useSystemEmailsPage";
import { SystemEmailCatalogueFilters } from "./SystemEmailCatalogueFilters";
import { SystemEmailCatalogueResults } from "./SystemEmailCatalogueResults";

export function SystemEmailCataloguePanel() {
  const catalogue = useSystemEmailCatalogue();
  return (
    <Stack gap="md">
      <SystemEmailCatalogueFilters
        dispatch={catalogue.dispatch}
        state={catalogue.state}
      />
      <SystemEmailCatalogueResults
        entries={catalogue.entries}
        error={catalogue.registry.error}
        filtered={catalogue.filtered}
        loading={catalogue.registry.isLoading}
        success={catalogue.registry.isSuccess}
      />
    </Stack>
  );
}
